import Foundation from 'foundation-sites'

Foundation.addToJquery($)

$(document).ready(() => {
  $(document).foundation()
})
